import defaultOptions from "./options";

export default {
  name: "customDetector",

  lookup() {
    let lang = defaultOptions.defaultLang;
    const segments = window.location.pathname.split("/");

    if (
      segments.length > 1 &&
      defaultOptions.supportedLangs.includes(segments[1])
    ) {
      lang = segments[1];
    }

    return lang;
  },

  cacheUserLanguage() {},
};
